import React, { Component, PropTypes } from 'react';
import Dropzone from 'react-dropzone';

import axios from 'axios';
import qs from 'qs';
import baseUrl from '../../../utils/baseUrl';

import connect from '../../../utils/connect';
import { dispatchError } from '../../../actions/errors';

import Spinner from '../../svg/spinner';
import ConfirmDialog from '../confirm';
import Image from '../../image/image';

import dropUpload from './drop-upload.png';
import dropRemove from './drop-remove.png';

const STATUS_INITIAL = 0;
const STATUS_UPLOADING = 1;
const STATUS_PREVIEWING = 2;

class InputDropzoneDisplay extends Component {
	static propTypes = {
		name: PropTypes.string.isRequired,
		preview: PropTypes.oneOfType([
			PropTypes.oneOf([false]),
			PropTypes.string,
			PropTypes.object,
		]).isRequired,
		params: PropTypes.object.isRequired,
		onChange: PropTypes.func.isRequired,
		onClear: PropTypes.func.isRequired,
		onUpload: PropTypes.func.isRequired,
		onFail: PropTypes.func.isRequired,
		bindOpen: PropTypes.func.isRequired,
		recommended: PropTypes.shape({
			width: PropTypes.number.isRequired,
			height: PropTypes.number.isRequired,
		}),
		disableDelete: PropTypes.bool.isRequired,
	};

	static defaultProps = {
		preview: false,
		width: 270,
		height: false,
		aspect: false,
		params: {},
		recommended: {
			width: 0,
			height: 0,
		},
		disableDelete: false,
		/*jscs:disable requirePaddingNewLinesAfterBlocks*/
		onChange: function() {},
		onClear: function() {},
		onUpload: function() {},
		onFail: function() {},
		bindOpen: function() {},
	};

	constructor(props) {
		super();

		let width = this.getWidth(props);

		this.state = {
			preview: props.preview,
			status: props.preview ? STATUS_PREVIEWING : STATUS_INITIAL,
			width: width,
			height: props.height ? props.height : (props.aspect ? Math.floor(width * props.aspect) : 'auto'),
		};
	}

	componentWillReceiveProps(nextProps) {
		if (
			(nextProps.preview && nextProps.preview !== this.props.preview) ||
			nextProps.browser.window.width !== this.props.browser.window.width
		) {
			this.setWidthState(nextProps);
		}
	}

	componentDidMount() {
		// this.refs not avail until after mount, so we call it again here
		this.setWidthState(this.props);

		// let parent have access to programatically opening dropzone upload dialog
		this.props.bindOpen(() => {
			this.refs.dropzone.open();
		});
	}

	render() {
		return (
			<Dropzone
				ref='dropzone'
				disableClick={this.props.disableClick}
				multiple={this.props.multiple}
				accept={this.props.accept}
				onDropAccepted={this.onDrop.bind(this)}
				style={{
					width: this.state.width,
					height: this.state.height,
				}}
				className='input-dropzone'
				activeClassName='input-dropzone--active'
				rejectClassName='input-dropzone--reject'
			>
				<div className='input-dropzone__item'>
					{this.renderContent()}

					<ConfirmDialog ref='confirm' />
				</div>
			</Dropzone>
		);
	}

	renderContent() {
		switch (this.state.status) {
			case STATUS_INITIAL:
			case STATUS_PREVIEWING:
		}

		let helpFormat = 'input-dropzone__help__centerer';
		if (this.state.height < 300 && this.state.width > 155 && this.props.aspect && this.props.aspect < 0.4) {
			helpFormat += ' input-dropzone__help__centerer--wide';
		} else if (this.state.height < 100 || this.state.width < 155) {
			helpFormat += ' input-dropzone__help__centerer--hidetext';
		}
		//if (this.state.status === STATUS_INITIAL || this.state.status === STATUS_PREVIEWING) {}

		return (
			<div className='input-dropzone__container' ref='container'>

				<div className={'input-dropzone__uploading' + (this.state.status === STATUS_UPLOADING ? ' input-dropzone__uploading--show' : '')}>
					<Spinner size='32px' className='input-dropzone__uploading__centerer' />
				</div>

				<div className={'input-dropzone__preview pixel-pattern pixel-pattern--darker' + (this.state.status === STATUS_PREVIEWING ? ' input-dropzone__preview--show' : '')}>
					{(this.state.status === STATUS_PREVIEWING) && (
						(typeof this.state.preview === 'string') ? (
							<img src={this.state.preview} alt='' />
						) : (
							<Image img={this.state.preview} span='' alt='' />
						)
					)}
				</div>

				<div className={'input-dropzone__help' + (this.state.status === STATUS_PREVIEWING || this.state.status === STATUS_UPLOADING ? ' input-dropzone__help--previewing' : '')}>

					{(!this.props.disableDelete) && (
						<div className='input-dropzone__help__delete' onClick={this.clearUpload.bind(this)}>
							<img {...dropRemove} className='' />
						</div>
					)}

					<div className={helpFormat}>
						<div className='input-dropzone__help__image'>
							<img {...dropUpload} className='' />
						</div>


						<div className='input-dropzone__help__text'>
							{((this.props.browser.window.width <= 719) && (
								<span>Tap to upload a new image</span>
							)) || (
								<span>Drag an image here or <a>browse</a> to upload.</span>
							)}

						</div>
					</div>
				</div>
			</div>
		);
	}

	setWidthState(props) {
		let width = this.getWidth(props);

		let preview = this.state.preview || props.preview;

		this.setState({
			...this.state,
			preview,
			status: (this.state.preview || props.preview) ? STATUS_PREVIEWING : STATUS_INITIAL,
			width,
			height: props.height ? props.height : (props.aspect ? Math.floor(width * props.aspect) : 'auto'),
		});
	}

	getWidth(props) {
		let maxWidth = props.width || 1400;

		let calculatedMaxWidth = ((container) => {
			if (container) {
				let mainParentContainer = container;

				while (mainParentContainer && mainParentContainer.classList && !mainParentContainer.classList.contains('form-dropzone')) {
					mainParentContainer = mainParentContainer.parentElement;
				}

				if (!mainParentContainer) {
					return maxWidth;
				}

				let containerComputedStyle = window.getComputedStyle(mainParentContainer);
				let parentComputedStyle = window.getComputedStyle(mainParentContainer.parentElement);

				maxWidth = (
					mainParentContainer.parentElement.offsetWidth -
					(parseInt(containerComputedStyle.paddingLeft, 10) || 0) -
					(parseInt(containerComputedStyle.paddingRight, 10) || 0) -
					(parseInt(parentComputedStyle.paddingLeft, 10) || 0) -
					(parseInt(parentComputedStyle.paddingRight, 10) || 0)
				);

				return (props.width > maxWidth) ? maxWidth : props.width;
			} else {
				return maxWidth;
			}
		})(this.refs.container);

		if (calculatedMaxWidth <= maxWidth) {
			return calculatedMaxWidth;
		}

		if (props.browser.window.width <= 567) {
			return (props.width < 262) ? props.width : 262;
		} else if (props.browser.window.width <= 719) {
			return (props.width < 354) ? props.width : 354;
		}

		return props.width;
	}

	onDrop(files) {
		let data = new FormData();
		data.append('file', files[0]);

		if (files[0] && files[0].size && files[0].size >= 20000000) {
			return this.props.dispatch(dispatchError({ message: 'Woah there!, that file is not small enough. (max. 20mb)' }));
		}

		if (/image/.test(files[0].type) && this.props.recommended.width && this.props.recommended.height && window.FileReader) {
			const reader = new FileReader();
			reader.addEventListener('load', () => {
				const img = new window.Image();
				img.src = reader.result;

				img.onload = () => {
					if (img.width !== this.props.recommended.width || img.height !== this.props.recommended.height) {
						this.refs.confirm
						.confirm(`The image you uploaded does not match the recommend size (${this.props.recommended.width}x${this.props.recommended.height}), please check that it looks the way you want it to.`, 'Ok', false)
						.then(() => {})
						.catch(() => {});
					}
				};
			}, false);

			reader.readAsDataURL(files[0]);
		}

		let params = {
			...this.props.params,
			name: this.props.name,
		};

		// fake a post
		this.setState({ ...this.state, status: STATUS_UPLOADING });
		axios.post(baseUrl + this.props.path, data, {
			params: params,
			paramsSerializer: function(params) {
				return qs.stringify(params)
			},
		})
		.then((response) => {
			if (response.data.path) {
				this.setState({ ...this.state, preview: response.data.path, status: STATUS_PREVIEWING });
			}
			this.props.onUpload(response);
		})
		.catch((response) => {
			this.setState({ ...this.state, status: STATUS_INITIAL });
			this.props.dispatch(dispatchError(response.data));
			this.props.onFail(response);
		});
	}

	clearUpload(e) {
		e.preventDefault();
		e.stopPropagation();

		this.refs.confirm
		.confirm('Are you sure you want to remove this file?')
		.then(() => {
			let data = new FormData();
			data.append('name', this.props.name);

			// optimistic update
			this.setState({ ...this.state, preview: false, status: STATUS_INITIAL });

			let params = {
				...this.props.params,
				name: this.props.name,
			};

			axios.delete(baseUrl + this.props.path, {
				params: params,
				paramsSerializer: function(params) {
					return qs.stringify(params)
				},
			})
			.then((response) => {
				this.props.onClear();
			})
			.catch((response) => {
				//this.setState({ ...this.state, status: STATUS_PREVIEWING });
				this.props.dispatch(dispatchError(response.data));

				this.props.onClear(); // @TODO REMOVE WHEN DELETE CALL WORKS

				this.props.onFail();
			});
		})
		.catch(() => {});
	}
}

export default connect(InputDropzoneDisplay);



/** WEBPACK FOOTER **
 ** ./frontend/components/form/dropzone/dropzoneDisplay.js
 **/